import React, { useEffect, useMemo, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { t } from '~/helpers';
import api from '~/services/api';
import qs from 'querystring';
import * as S from './styles'

import { isEmpty } from 'lodash';


import { Button } from '@material-ui/core';
import { Spinner } from '~/components';
import { Input, Select, InputText } from '~/components/Form';
import { SelectComplete } from '~/componentslocal';
import {
    storeData,
    updateData,
} from '~/store/modules/equipamento/actions';
import { closeDialog } from '~/store/modules/dialog/actions';
import { toast } from 'react-toastify';

export default function CreateOrUpdate({ reference, data, create }) {
    const dispatch = useDispatch();

    const redux = useSelector(state => state.equipamento)

    const [cleanTransponder1, setCleanTransponder1] = useState(false)
    const [cleanTransponder2, setCleanTransponder2] = useState(false)

    const options = useMemo(
        () => [
            { label: 'Ativo', value: 1 },
            { label: 'Inativo', value: 2 },
        ],
        []
    );

    const optionsEngate = useMemo(
        () => [
            { label: 'Com engate', value: 1 },
            { label: 'Sem engate', value: 2 },
        ],
        []
    );

    const optionsBocais = useMemo(
        () => [
            { label: 'Sem Lacre', value: 0 },
            { label: '2 - Bocais', value: 2 },
            { label: '4 - Bocais', value: 4 },
        ],
        []
    );

    const initials = create ? {
        ...data,
        tipo_engate: 2,
        num_bocais: 0,
        status: 1,
        transponder01: '',
        transponder02: ''
    }
        : {
            ...data,
            equipamento: redux.find.veic_cod_veic,
            empresa: redux.find.empe_cod_emp,
            tipo_equipamento: redux.find.tive_cod_tive,
            modelo: redux.find.mode_cod_mode,
            transponder01: redux.find.veic_transponder1,
            transponder02: redux.find.veic_transponder2,
            volume_tanque: redux.find.veic_vol_tnq,
            tipo_engate: Number(redux.find.veic_tipo_engate),
            num_bocais: redux.find.vela_num_lacre,
            status: redux.find.veic_st_reg === 'S' ? 1 : 2

        };


    const handleValidateEquipamento = useCallback(async (cod_veic, cod_empe) => {

        const params = {
            wherefield: ['veic_cod_veic', 'empe_cod_emp'],
            valuewherefield: [cod_veic, cod_empe],
            typewherefield: ['EQUALS', 'EQUALS']
        }

        const response = await api.get('veiculo', {
            params,
            paramsSerializer: (param) => qs.stringify(param),
        });

        if (!isEmpty(response.data.items)) {
            return true
        }
        return false

    }, [])

    async function handleSubmit(param) {
        try {

            const schema = Yup.object().shape({
                equipamento: Yup.string()
                    .typeError('Campo obrigatório')
                    .required('Campo obrigatório').min(5, 'Deve ter no mínimo 5 caracteres')
                    .max(10, 'Deve ter no máximo 10 caracteres'),
                empresa: Yup.string()
                    .typeError('Campo obrigatório')
                    .required('Campo obrigatório'),
                tipo_equipamento: Yup.string()
                    .typeError('Campo obrigatório')
                    .required('Campo obrigatório'),
                modelo: Yup.string()
                    .typeError('Campo obrigatório')
                    .required('Campo obrigatório'),
                volume_tanque: Yup.number()
                    .typeError('Campo obrigatório')
                    .required('Campo obrigatório')
                    .min(1, 'O valor deve ser maior que 0'),
                tipo_engate: Yup.string()
                    .typeError('Campo obrigatório')
                    .required('Campo obrigatório'),
                num_bocais: Yup.string()
                    .typeError('Campo obrigatório')
                    .required('Campo obrigatório'),
                status: Yup.string()
                    .typeError('Campo obrigatório')
                    .required('Campo obrigatório'),
            });

            await schema.validate(param, {
                abortEarly: false,
            });

            reference.current.setErrors({});

            if (create) {
                const equipIsValid = await handleValidateEquipamento(param.equipamento, param.empresa)
                if (equipIsValid) {
                    throw ('Número de equipamento já cadastrado nessa empresa !')
                }
            }

            const objSend = {
                codVeiculo: String(param.equipamento),
                codEmpresa: param.empresa,
                codTipoVeiculo: String(param.tipo_equipamento),
                modelo: String(param.mode_descricao),
                volumeTanque: Number(param.volume_tanque),
                tipoEngate: String(param.tipo_engate),
                numBocais: String(param.num_bocais),
                tbModelo: String(param.modelo),
                transponder01: param.transponder01 ?? '',
                transponder02: param.transponder02 ?? '',
                status: String(param.status),
            };


            if (create) {
                await dispatch(storeData(objSend, redux.params));
            } else {
                await dispatch(updateData(objSend, redux.params));
            }
            dispatch(closeDialog())
        } catch (err) {
            const validationErrors = {};
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message.replace(
                        `${error.path} `,
                        ''
                    );
                });
                reference.current.setErrors(validationErrors);
            } else {
                toast.error(err)
            }
        }
    }


    return (
        <>
            {redux.loading ? (
                <div style={{ height: '14rem', width: '50rem' }}>
                    <Spinner loading />
                </div>
            ) : (
                <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
                    {create ?
                        <>
                            <InputText name="equipamento" label="Equipamento" mask="**********" placeholder="" />
                            <SelectComplete
                                name="empresa"
                                title="Empresa"
                                label="empe_desc"
                                unique="empe_cod_emp"
                                url="veiculo/empresas"

                            />
                        </>
                        :
                        <>
                            <Input name="equipamento" label="Equipamento" disabled />
                            <SelectComplete
                                name="empresa"
                                title="Empresa"
                                label="empe_desc"
                                unique="empe_cod_emp"
                                url="veiculo/empresas"
                                disabled

                            />
                        </>

                    }


                    <SelectComplete
                        name="tipo_equipamento"
                        title="Tipo Equipamento"
                        label="tive_desc"
                        unique="tive_cod_tive"
                        url="veiculo/tipoveiculos"
                    />

                    <SelectComplete
                        name="modelo"
                        title="Modelo"
                        label="mode_descricao"
                        unique="mode_cod_mode"
                        url="veiculo/modelo"
                        hiddens={[{ name: 'mode_descricao' }]}
                        params={{
                            wherefield: 'mode_st_reg',
                            valuewherefield: 'S',
                            typewherefield: 'EQUALS'
                        }}
                    />

                    <>
                        <S.TransponderContainer>
                            {cleanTransponder1 ? <Input name="cleantransponder01" label="Transponder 01" disabled={true} value="" />
                                :
                                <Input name="transponder01" label="Transponder 01" disabled={true} />

                            }
                            <S.CleanButton
                                style={{ marginTop: '2px', marginBottom: '12px', marginLeft: '5px' }}
                                color="primary"
                                size="small"
                                variant="contained"
                                onClick={() => setCleanTransponder1(true)}
                                disabled={cleanTransponder1}
                            >
                                Limpar
                            </S.CleanButton>
                        </S.TransponderContainer>
                        <S.TransponderContainer>
                            {cleanTransponder2 ? <Input name="cleantransponder02" label="Transponder 02" disabled={true} value="" />
                                :

                                <Input name="transponder02" label="Transponder 02" disabled={true} />
                            }
                            <Button
                                style={{ marginTop: '2px', marginBottom: '12px', marginLeft: '5px' }}
                                color="primary"
                                size="small"
                                variant="contained"
                                disabled={cleanTransponder2}
                                onClick={() => setCleanTransponder2(true)}
                            >
                                Limpar
                            </Button>
                        </S.TransponderContainer>

                    </>


                    <Input name="volume_tanque" label="Volume Tanque" type="number" InputProps={{ min: 1, max: 999999 }} />

                    <Select name="tipo_engate" label="Tipo Engate" options={optionsEngate} />
                    <Select name="num_bocais" label="Núm. Bocais" options={optionsBocais} />
                    <Select name="status" label="Status" options={options} />
                </Form>
            )}
        </>
    );
}

CreateOrUpdate.propTypes = {
    reference: PropTypes.objectOf(PropTypes.any).isRequired,
    create: PropTypes.bool.isRequired,
    data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
    data: {},
};
